<template lang="html">
  <div>
    <h1>Importer</h1>
    <p>{{ id }}</p>
    <p>
      <button @click="$store.dispatch('createSlideArrayFromLibrary')">
        createSlideArrayFromLibrary
      </button>
    </p>

    <h2>Queue</h2>
    <p>
      <button v-if="queue.length > 0" @click="uploadNextInQueue">
        Upload queue
      </button>
      <progress :value="progress" max="100" />
    </p>

    <div v-for="(item, idx) in queue" :key="'queue' + idx">
      <p v-if="item.type == 'image'">
        <img :src="item.url" class="img-display" />
      </p>
      <p v-if="item.type == 'audio'">
        <audio controls>
          <source :src="item.url" type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </p>
    </div>

    <form @change="processFiles">
      Add images and audio and xml: <input type="file" multiple />
    </form>

    <h2>Library</h2>
    <div v-if="showData">
      <img
        v-for="(image, idx) in showData.data.images"
        :key="'library' + idx"
        :src="'https://s3.amazonaws.com/users.soundslides.media/' + image.key"
        class="img-display"
      />
      <p v-if="showData.data.audio">
        <audio controls>
          <source
            :src="
              'https://s3.amazonaws.com/users.soundslides.media/' +
                showData.data.audio.key
            "
            type="audio/mpeg"
          />
          Your browser does not support the audio element.
        </audio>
      </p>
    </div>
    <ObjectPrint :data="showData" />
  </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import ObjectPrint from "@/components/ObjectPrint";
export default {
  name: "Import",
  components: {
    ObjectPrint
  },
  data() {
    return {
      audio_file: null,
      uploaded_percentage: 0,
      queue: [],
      progress: 100
    };
  },
  computed: {
    id() {
      return this.$store.state.currentShowDetails.ssid;
    },
    showData() {
      return this.$store.state.currentShowDetails;
    }
  },
  mounted() {},
  methods: {
    addToQueue(item) {
      this.queue.push(item);
      if (item.type === "image") {
        _.remove(this.images, item);
      }
    },
    uploadNextInQueue() {
      var item = this.queue.shift();
      if (item.type === "image") {
        this.uploadImage(item);
      }
      if (item.type === "audio") {
        this.uploadAudio(item);
      }
    },
    uploadImage(image) {
      var _v = this;
      let formData = new FormData();
      var filename = Date.now() + "_" + image.name;
      var key = this.id + "/" + filename;
      formData.append("key", key);
      formData.append("AWSAccessKeyId", "AKIAJDQUYKFKPYLVLLOA");
      formData.append("acl", "public-read");
      formData.append("success_action_status", "201");
      formData.append("policy", this.showData.policies.images.policy);
      formData.append("signature", this.showData.policies.images.signature);
      formData.append("Content-Type", "image/jpeg");
      formData.append("Cache-Control", "public, max-age=315576000, immutable");
      formData.append("file", image.fileObj);
      console.log(">> formData >> ", formData);
      _v.progress = 0;
      // You should have a server side REST API
      axios
        .post("https://s3.amazonaws.com/users.soundslides.media/", formData, {
          onUploadProgress: progressEvent => {
            console.log(progressEvent);
            var _uploaded = Math.ceil(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            _v.progress = _uploaded;
          }
        })
        .then(function(e) {
          console.log(e);
          console.log("SUCCESS!!");
          _v.imageUploaded({
            key: key,
            filename: filename,
            name: image.name
          });
        });
    },
    uploadAudio(audio) {
      var _v = this;
      let formData = new FormData();
      var filename = Date.now() + "_audio.mp3";
      var key = this.id + "/" + filename;
      formData.append("key", key);
      formData.append("AWSAccessKeyId", "AKIAJDQUYKFKPYLVLLOA");
      formData.append("acl", "public-read");
      formData.append("success_action_status", "201");
      formData.append("policy", this.showData.policies.audio.policy);
      formData.append("signature", this.showData.policies.audio.signature);
      formData.append("Content-Type", "audio/mpeg");
      formData.append("Cache-Control", "public, max-age=315576000, immutable");
      formData.append("file", audio.fileObj);
      console.log(">> formData >> ", formData);
      _v.progress = 0;
      // You should have a server side REST API
      axios
        .post("https://s3.amazonaws.com/users.soundslides.media/", formData, {
          onUploadProgress: progressEvent => {
            console.log(progressEvent);
            var _uploaded = Math.ceil(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            _v.progress = _uploaded;
          }
        })
        .then(function(e) {
          console.log(e);
          console.log("SUCCESS!!");
          _v.audioUploaded({
            key: key,
            filename: filename,
            name: audio.name,
            duration: audio.duration
          });
        });
    },
    imageUploaded(image) {
      var details = this.showData;
      if (!details.data.images) {
        details.data.images = [];
      }
      details.data.images.push({
        key: image.key,
        filename: image.filename,
        name: image.name
      });
      this.$store.commit("setShowDetails", details);
      this.$store.dispatch("updateCurrentShow");
      if (this.queue.length > 0) {
        this.uploadNextInQueue();
      }
    },
    audioUploaded(audio) {
      var details = this.showData;
      details.data.audio = {
        key: audio.key,
        filename: audio.filename,
        name: audio.name,
        duration: audio.duration
      };
      this.$store.commit("setShowDetails", details);
      this.$store.dispatch("updateCurrentShow");
      if (this.queue.length > 0) {
        this.uploadNextInQueue();
      }
    },
    processFiles(e) {
      var _v = this;
      console.log(e.target.files);
      _.each(e.target.files, i => {
        console.log(i.type);
        if (i.type === "image/jpeg") {
          _v.queue.push({
            name: i.name,
            url: window.URL.createObjectURL(i),
            fileObj: i,
            type: "image"
          });
        }
        if (i.type === "audio/mp3" || i.type === "audio/mpeg") {
          // Create audio object for reading duration.
          var audio = new Audio();
          audio.addEventListener("canplaythrough", function() {
            _v.audio_file.duration = audio.duration;
            _v.queue.push(_v.audio_file);
          });
          var objectUrl = window.URL.createObjectURL(i);
          _v.audio_file = {
            name: i.name,
            url: objectUrl,
            duration: null,
            fileObj: i,
            type: "audio"
          };
          // Attach to audio obj to read the duration.
          audio.src = objectUrl;
        }
        if (i.type === "text/xml") {
          var xml_file = {
            name: i.name,
            url: window.URL.createObjectURL(i),
            type: "xml"
          };
          console.log(xml_file);
          console.log("Do nothing with xml yet!");
          // Likely read the xml file in at this point!
          //_v.queue.push(xml_file);
        }
        // If you need dataurl.
        //var reader = new FileReader();
        //reader.onload = function(event) {
        //  _v.images.push(event.target.result);
        //}
        //reader.readAsDataURL(i);
      });
    }
  }
};
</script>

<style lang="css" scoped>
.img-display{
  width: 100px;
  height: auto;
}
.class{
  max-width: 100%;
  max-height: 100%;
}
</style>
